<template>
  <div>
    <div ref="container" aria-describedby="tooltip">
      <slot />
    </div>
    <div
      ref="tooltip"
      role="tooltip"
      class="hidden text-xs text-primary bg-white rounded-md p-1 border border-primary max-w-xs text-center dark:bg-gray-800 dark:border-primary-light dark:text-gray-100 z-50"
      :class="{ '!hidden': !text.length && !$scopedSlots.content }"
      :title="text"
    >
      <slot name="content">
        {{ text }}
      </slot>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

const showEvents = ["mouseenter", "focus"];
const hideEvents = ["mouseleave", "blur"];

export default {
  name: "JoszakiHoverText",
  props: {
    text: {
      type: String,
      default: "",
    },
    placement: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      popper: null,
    };
  },
  mounted() {
    this.popper = createPopper(this.$refs.container, this.$refs.tooltip, {
      placement: this.placement,
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10],
          },
        },
      ],
    });

    for (const event of showEvents) {
      this.$refs.container.addEventListener(event, this.showTooltip);
    }

    for (const event of hideEvents) {
      this.$refs.container.addEventListener(event, this.hideTooltip);
    }
  },
  beforeDestroy() {
    for (const event of showEvents) {
      this.$refs.container.removeEventListener(event, this.showTooltip);
    }

    for (const event of hideEvents) {
      this.$refs.container.removeEventListener(event, this.hideTooltip);
    }

    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    setEventListeners(enabled) {
      this.popper.setOptions((options) => ({
        ...options,
        modifiers: [...options.modifiers, { name: "eventListeners", enabled }],
      }));
    },
    showTooltip() {
      this.$refs.tooltip.classList.remove("hidden");
      this.$refs.tooltip.classList.add("block");

      this.setEventListeners(true);

      this.popper.update();
    },
    hideTooltip() {
      this.$refs.tooltip.classList.remove("block");
      this.$refs.tooltip.classList.add("hidden");

      this.setEventListeners(false);
    },
  },
};
</script>
